import { Link } from "react-router-dom";
import { getByCategory, sortContent } from "@/lib/content";
import SectionHeader from "@/components/base/SectionHeader";

export default function EntertainmentList() {
  const list = sortContent(getByCategory("entertainment-news"), "heat-desc").slice(
    0,
    6
  );

  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <SectionHeader
          title="热门娱乐新闻"
          subtitle="明星动态、综艺资讯与行业热点一网打尽"
          moreTo="/category/entertainment-news"
          moreLabel="更多娱乐新闻"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {list.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group flex gap-4 rounded-xl bg-background-50 border border-background-200 p-4 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-28 h-20 md:w-32 md:h-24 shrink-0 rounded-lg overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="min-w-0 flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="hidden sm:block text-xs text-foreground-500 leading-relaxed line-clamp-2 mt-2">
                  {item.summary}
                </p>
                <span className="text-xs text-foreground-400 mt-auto pt-2 flex items-center gap-1">
                  <i className="ri-calendar-line" /> {item.date}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}